module.exports = __webpack_public_path__ + "static/media/acaritouch.4dd7496d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/aranha_roja_tomate/preventiva/acaritouch.png
// module id = 2383
// module chunks = 3